import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components/macro'

function Theme({ jobResult, children }) {
  const { theme, GlobalStyle } = jobResult

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        {children}
        <GlobalStyle />
      </React.Fragment>
    </ThemeProvider>
  )
}

Theme.propTypes = {
  jobResult: PropTypes.shape({
    GlobalStyle: PropTypes.func.isRequired,
    theme: PropTypes.object.isRequired
  }).isRequired,
  children: PropTypes.node
}

export default Theme
